import { axios } from '@/utils/request'

export function fetchList (params) {
  return axios({
    url: '/dailyHireWorker/selectPage',
    method: 'GET',
    params: {
      ...params
    }
  })
}

// 导出主材成本统计
export function download (params) {
  return axios({
    url: '/dailyHireWorker/download',
    method: 'get',
    params: params,
    responseType: 'arraybuffer'
  })
}
// 审计
export function audit (data) {
  return axios({
    url: '/dailyHireWorker/audit/' + data.id + '/' + data.audit,
    method: 'GET'
  })
}

// 财务确认总金额
export function isAmount (data) {
  return axios({
    url: '/dailyHireWorker/isAmount/' + data.id + '/' + data.isAmount,
    method: 'GET'
  })
}
